import { render, staticRenderFns } from "./container.vue?vue&type=template&id=24af0d32&scoped=true"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"
import style0 from "./container.vue?vue&type=style&index=0&id=24af0d32&prod&scoped=true&lang=scss"
import style1 from "./container.vue?vue&type=style&index=1&id=24af0d32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af0d32",
  null
  
)

export default component.exports